module.exports = __webpack_public_path__ + "c6263afa377537c90ab4290abc9fbb6f.svg";